const SCRIPT_SRC = 'https://accounts.google.com/gsi/client';

// The GSI client breaks if its script runs more than once per page, and the
// app remounts on language switch, so the script is loaded once per page.
// Its built-in strings (the button drawn before Google's iframe loads) come
// from `hl` and can't change later; the iframe follows `renderButton` locale.
let scriptPromise: Promise<typeof google.accounts.id> | undefined;

export function loadGoogleIdentity(
  locale: string
): Promise<typeof google.accounts.id> {
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `${SCRIPT_SRC}?hl=${encodeURIComponent(locale)}`;
      script.async = true;
      script.onload = () => {
        if (window.google?.accounts?.id) {
          resolve(window.google.accounts.id);
        } else {
          reject(new Error('Google Identity Services is not available'));
        }
      };
      script.onerror = () => {
        scriptPromise = undefined;
        script.remove();
        reject(new Error('Failed to load Google Identity Services'));
      };
      document.body.appendChild(script);
    });
  }
  return scriptPromise;
}
